module.exports = __webpack_public_path__ + "d664201f/img/archive-icon.0a6a9de3.svg";